import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';

var _excluded = ["children"];
var FormGroup = function FormGroup(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, rest, children);
};
var FormGroupMemoized = /*#__PURE__*/React.memo(FormGroup);
FormGroupMemoized.displayName = 'FormGroup';
FormGroup.defaultProps = {
  role: 'group'
};

export { FormGroupMemoized as FormGroup };
//# sourceMappingURL=FormGroup.js.map
